// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__eKvpC","consentsList":"PatientConsents_consentsList__TQc8d","consentsListEmpty":"PatientConsents_consentsListEmpty__X4Jz-"};